import { useQuery } from "react-query";

import { fetchSdlDataConfig } from "../../../services";
import { IKeyStringAndValue } from "../../types/Types";

const useGetTranslationConfig = (listView: string) => {
  return useQuery("translation", async () => {
    const transData = await fetchSdlDataConfig(listView, "translations");
    const data = transData.data.items.edges[0].node.content.data.settings;

    return data
      ? data.$values?.map((fields: IKeyStringAndValue) => {
          const splitArray = fields?.value.split("|");
          const name = fields.name;
          const oldValue = splitArray[0].trim();
          const translation = splitArray[1].trim();

          return { name: name, oldValue: oldValue, translation: translation };
        })
      : [{ name: "", oldValue: "", translation: "" }];
  });
};
export default useGetTranslationConfig;
